import dayjs from '~/timeInit';

import type { ExperienceOffer } from '~/services/ExperiencesService';
import type { PublicOffer } from '~/services/PublicOfferService';

export function getHotelOnlineStatus(offer?: PublicOffer, now = dayjs()): boolean | undefined {
  if (!offer || offer.type === 'bedbank_hotel') {
    return undefined;
  }

  const schedule = 'schedules' in offer ? offer.schedules?.onlinePurchase : undefined;
  if (!schedule) {
    return false;
  }

  const start = dayjs(schedule.start);
  const end = dayjs(schedule.end);
  if (!schedule.start || !schedule.end || !start.isValid() || !end.isValid() || end.isBefore(start)) {
    return undefined;
  }

  return !now.isBefore(start) && !now.isAfter(end);
}

export function getExperienceOnlineStatus(offer?: Pick<ExperienceOffer, 'status'>): boolean | undefined {
  if (offer?.status === 'ONLINE') {
    return true;
  }
  if (offer?.status === 'UNAVAILABLE') {
    return false;
  }
  return undefined;
}
